// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assests/cards-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.earn-passively {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.earn-section-title {
  font-size: 50px;
  font-weight: 700;
  text-align: center;
}

.earn-section-para {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  color: #000000;
  text-align: center;
}

.yield-farming {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
}

.yeild-cards-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 7rem;
}

.yield-card-1 {
  width: 40%;
  height: auto;
  background: linear-gradient(to bottom, #fef1e5, #fef1e500);
  border: 1px solid #f69737;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  padding: 20px 25px;
}

.yield-cards-title {
  font-size: 36px;
  line-height: 45px;
  font-weight: 600;
}

.yield-cards-para {
  font-size: 20px;
  font-weight: 500;
  line-height: normal;
  color: #515151;
}

.yield-card-2 {
  width: 43%;
  height: auto;
  background: linear-gradient(to bottom, #f8e9ff, #fbf4ff00);
  border: 1px solid #632e71;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1rem;
  padding: 25px 30px;
}

.farm-mforge {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
}

.mForge-Img {
  width: 80%;
}

.stake-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 1.5rem;
}

.earn-cards {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 30%;
  /* height: fit-content; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 20px 25px;
  box-shadow: 2px 2px 7px 0 #0000004d;
  border-radius: 14px;
  border-bottom: 3px solid #0e4e8d;
}

.earn-cards:hover {
  scale: 1.05;
  cursor: pointer;
}

.earn-cards h4 {
  font-size: 25px;
  font-weight: 600;
  line-height: 40px;
}

.earn-cards p {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #515151;
  text-align: center;
}

.red-circles {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #e84427;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 36px;
}
.red-circles_resp {
  vertical-align: middle;
  padding: 3px;
  width: 50px;
  text-align: center;
  height: 50px;
  border-radius: 50%;
  background: #e84427;
  color: white;
  font-weight: 600;
  font-size: 27px;
}

.spteper_cnt{
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 20px;
  background-color: #e84427;
  display: flex;
  align-items: center;
}

.red-lines {
  width: 3px;
  height: 120px;
  background-color: #e84427;
  margin-right: 1.3rem;
}

.steps-section-2 {
  display: flex;
  flex-direction: column;
  gap: 6.8rem;
}

.steps-section-2 > div:nth-child(3) > h1:first-child{
  margin-top: 10px;
}

.steps-section-2 h1 {
  color: #234b9a;
  font-size: 30px;
  line-height: 40px;
  font-weight: 600;
}


.steps-section-2 p {
  font-size: 20px;
  color: #515151;
  font-weight: 500;
  line-height: 30px;
}

.hrefReadMore {
  text-decoration: none;
}

@media screen and (max-width: 1040px) {
  .earn-cards {
    width: 55%;
  }
}

@media screen and (max-width: 992px) {
  .earn-passively h1 {
    width: 100%;
  }

  .earn-passively > p {
    width: 90%;
  }

  .yeild-cards-container {
    gap: 4rem;
  }

  .steps-section-2 {
    gap: 94px;
  }
}

@media screen and (max-width: 768px) {
  .steps-section-2 h1 {
    font-size: 30px;
    line-height: normal;
  }

  .steps-section-2 p {
    font-size: 20px;
    line-height: normal;
  }

  .steps-section-2 {
    gap: 6rem;
  }
  .yield-card-1,
  .yield-card-2 {
    width: 100%;
    flex-grow: 1;
  }
  .isemnx{
    width: 85%;
  }
}

@media screen and (max-width: 720px) {
  .steps-section-2 {
    gap: 5.4rem;
  }
}

@media screen and (max-width: 600px) {
  .earn-cards {
    width: 95%;
    gap: 5px;
  }
  .earn-cards h4 {
    white-space: wrap;
    text-align: center;
    line-height: normal;
  }

  .earn-section-title {
    font-size: 32px;
    line-height: normal;
    font-weight: 700;
  }
  .farm-mforge p {
    width: 90%;
    text-align: justify;
  }
  .earn-section-para {
    font-size: 16px;
    text-align: center !important;
  }
  .yield-card-1 {
    width: 100%;
    gap: 0;
  }

  .yield-card-2 {
    width: 100%;
    gap: 0;
  }

  .earn-passively h1 {
    width: 100%;
    font-size: 32px;
    line-height: normal;
  }

  .earn-passively > p {
    width: 90%;
    text-align: center;
  }

  .mForge-Img {
    width: 90%;
  }

  .rspnsyf {
    width: 205px !important;
    margin: 0 auto;
  }
  .yield-cards-title {
    font-family: "Quicksand";
    font-size: 20px;
    font-weight: 600;
  }
  .yield-cards-para {
    font-size: 16px;
  }
  .yield-farming {
    gap: 1rem;
  }
  .yeild-cards-container {
    gap: 2rem;
  }
}

@media screen and (max-width: 470px) {
  .steps-section-2 h1 {
    font-size: 20px;
    line-height: normal;
  }

  .steps-section-2 p {
    font-size: 16px;
    line-height: normal;
  }
  .earn-cards h4 {
    font-size: 20px;
    font-weight: 700;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Earn/Earn.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0DAA0D;EAC1D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0DAA0D;EAC1D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mDAA6C;EAC7C,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;EACtB,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;EACA;;IAEE,WAAW;IACX,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,6BAA6B;EAC/B;EACA;IACE,WAAW;IACX,MAAM;EACR;;EAEA;IACE,WAAW;IACX,MAAM;EACR;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,uBAAuB;IACvB,cAAc;EAChB;EACA;IACE,wBAAwB;IACxB,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,SAAS;EACX;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".earn-passively {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.earn-section-title {\n  font-size: 50px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.earn-section-para {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  color: #000000;\n  text-align: center;\n}\n\n.yield-farming {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 3rem;\n}\n\n.yeild-cards-container {\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 7rem;\n}\n\n.yield-card-1 {\n  width: 40%;\n  height: auto;\n  background: linear-gradient(to bottom, #fef1e5, #fef1e500);\n  border: 1px solid #f69737;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1rem;\n  padding: 20px 25px;\n}\n\n.yield-cards-title {\n  font-size: 36px;\n  line-height: 45px;\n  font-weight: 600;\n}\n\n.yield-cards-para {\n  font-size: 20px;\n  font-weight: 500;\n  line-height: normal;\n  color: #515151;\n}\n\n.yield-card-2 {\n  width: 43%;\n  height: auto;\n  background: linear-gradient(to bottom, #f8e9ff, #fbf4ff00);\n  border: 1px solid #632e71;\n  border-radius: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1rem;\n  padding: 25px 30px;\n}\n\n.farm-mforge {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.mForge-Img {\n  width: 80%;\n}\n\n.stake-col {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 1.5rem;\n}\n\n.earn-cards {\n  background: url(\"../../assests/cards-bg.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  width: 30%;\n  /* height: fit-content; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  padding: 20px 25px;\n  box-shadow: 2px 2px 7px 0 #0000004d;\n  border-radius: 14px;\n  border-bottom: 3px solid #0e4e8d;\n}\n\n.earn-cards:hover {\n  scale: 1.05;\n  cursor: pointer;\n}\n\n.earn-cards h4 {\n  font-size: 25px;\n  font-weight: 600;\n  line-height: 40px;\n}\n\n.earn-cards p {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #515151;\n  text-align: center;\n}\n\n.red-circles {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: #e84427;\n  color: white;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-weight: 600;\n  font-size: 36px;\n}\n.red-circles_resp {\n  vertical-align: middle;\n  padding: 3px;\n  width: 50px;\n  text-align: center;\n  height: 50px;\n  border-radius: 50%;\n  background: #e84427;\n  color: white;\n  font-weight: 600;\n  font-size: 27px;\n}\n\n.spteper_cnt{\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-right: 20px;\n  background-color: #e84427;\n  display: flex;\n  align-items: center;\n}\n\n.red-lines {\n  width: 3px;\n  height: 120px;\n  background-color: #e84427;\n  margin-right: 1.3rem;\n}\n\n.steps-section-2 {\n  display: flex;\n  flex-direction: column;\n  gap: 6.8rem;\n}\n\n.steps-section-2 > div:nth-child(3) > h1:first-child{\n  margin-top: 10px;\n}\n\n.steps-section-2 h1 {\n  color: #234b9a;\n  font-size: 30px;\n  line-height: 40px;\n  font-weight: 600;\n}\n\n\n.steps-section-2 p {\n  font-size: 20px;\n  color: #515151;\n  font-weight: 500;\n  line-height: 30px;\n}\n\n.hrefReadMore {\n  text-decoration: none;\n}\n\n@media screen and (max-width: 1040px) {\n  .earn-cards {\n    width: 55%;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .earn-passively h1 {\n    width: 100%;\n  }\n\n  .earn-passively > p {\n    width: 90%;\n  }\n\n  .yeild-cards-container {\n    gap: 4rem;\n  }\n\n  .steps-section-2 {\n    gap: 94px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .steps-section-2 h1 {\n    font-size: 30px;\n    line-height: normal;\n  }\n\n  .steps-section-2 p {\n    font-size: 20px;\n    line-height: normal;\n  }\n\n  .steps-section-2 {\n    gap: 6rem;\n  }\n  .yield-card-1,\n  .yield-card-2 {\n    width: 100%;\n    flex-grow: 1;\n  }\n  .isemnx{\n    width: 85%;\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .steps-section-2 {\n    gap: 5.4rem;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .earn-cards {\n    width: 95%;\n    gap: 5px;\n  }\n  .earn-cards h4 {\n    white-space: wrap;\n    text-align: center;\n    line-height: normal;\n  }\n\n  .earn-section-title {\n    font-size: 32px;\n    line-height: normal;\n    font-weight: 700;\n  }\n  .farm-mforge p {\n    width: 90%;\n    text-align: justify;\n  }\n  .earn-section-para {\n    font-size: 16px;\n    text-align: center !important;\n  }\n  .yield-card-1 {\n    width: 100%;\n    gap: 0;\n  }\n\n  .yield-card-2 {\n    width: 100%;\n    gap: 0;\n  }\n\n  .earn-passively h1 {\n    width: 100%;\n    font-size: 32px;\n    line-height: normal;\n  }\n\n  .earn-passively > p {\n    width: 90%;\n    text-align: center;\n  }\n\n  .mForge-Img {\n    width: 90%;\n  }\n\n  .rspnsyf {\n    width: 205px !important;\n    margin: 0 auto;\n  }\n  .yield-cards-title {\n    font-family: \"Quicksand\";\n    font-size: 20px;\n    font-weight: 600;\n  }\n  .yield-cards-para {\n    font-size: 16px;\n  }\n  .yield-farming {\n    gap: 1rem;\n  }\n  .yeild-cards-container {\n    gap: 2rem;\n  }\n}\n\n@media screen and (max-width: 470px) {\n  .steps-section-2 h1 {\n    font-size: 20px;\n    line-height: normal;\n  }\n\n  .steps-section-2 p {\n    font-size: 16px;\n    line-height: normal;\n  }\n  .earn-cards h4 {\n    font-size: 20px;\n    font-weight: 700;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
